import { useAtomValue } from 'jotai';
import { FC } from 'react';
import { NotFound } from '~/components/not-found';
import { DiscoverInfoV2 } from '@discover/body/info/v2';
import { $CurrentAvailableDiscoverDataOrNull } from '@discover/shared/atom';

export const DiscoverInfoSection: FC = () => {
  const data = useAtomValue($CurrentAvailableDiscoverDataOrNull);

  if (!data) {
    return <NotFound />;
  }

  return (
    <section key="kep-info-section" id="discover-info">
      <DiscoverInfoV2 />
    </section>
  );
};
